import { useLocalData } from "../../common/hooks/useLocalData";
import { ProductsNav } from "@hatch-digital-nl/bravilor-storybook";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
    ProductTypeEnum,
    setFilteredCategories,
    setFilters,
    setProductType,
} from "./ProductRangeSlice";
import { CategoryItem } from "../../common/components/productRange/CategoryItem";
import { CategoryItemSkeleton } from "../../common/components/productRange/CategoryItemSkeleton";
import { CategoryListInterface } from "../../common/interfaces/CategoryListInterface";
import { useEffect, JSX } from "react";
import { RouteEnum } from "../../common/enums/RouteEnum";
import { ProductRangeHeader } from "../../common/components/productRange/ProductRangeHeader";
import { ContentNavigation } from "../../common/components/productRange/ContentNavigation";

const ProductRangePageContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const {
        gridLayout,
        productType,
        filteredCategories,
        productImages,
        isProcessingCategories,
        selectedFilters,
        mobileFiltersActive,
    } = useAppSelector((state) => state.productRange);
    const { categories, products, filters, getLocalImageUrl, isLoading } =
        useLocalData();

    useEffect(() => {
        if (filters.length > 0) {
            dispatch(setFilters(filters));
        }
    }, [filters, dispatch]);

    useEffect(() => {
        if (categories.length > 0 && products.length > 0) {
            dispatch(
                setFilteredCategories({
                    categories,
                    products,
                    productType,
                    getLocalImageUrl,
                    filters,
                    selectedFilters,
                }),
            );
        }
    }, [
        categories,
        products,
        productType,
        filters,
        selectedFilters,
        dispatch,
        getLocalImageUrl,
    ]);

    const productNavItems = [
        {
            type: ProductTypeEnum.MACHINES,
            text: "Machines",
            panelId: "machines",
        },
        {
            type: ProductTypeEnum.ACCESSORIES,
            text: "Accessories",
            panelId: "accessories",
        },
    ];

    const breadcrumbItems = [
        {
            label: "Product Range",
            link: RouteEnum.PRODUCT_RANGE,
            to: RouteEnum.PRODUCT_RANGE,
        },
        {
            label: productType === "accessories" ? "Accessories" : "Machines",
            to: RouteEnum.PRODUCT_RANGE,
        },
    ];

    return (
        <div className="p-product-range">
            <ProductRangeHeader breadcrumbItems={breadcrumbItems} />

            <ContentNavigation
                mobileFiltersActive={mobileFiltersActive}
                filters={filters}
                selectedFilters={selectedFilters}
                gridLayout={gridLayout}
            />

            <div className="p-product-range__content">
                <div className="p-product-range__content__nav">
                    <ProductsNav
                        activeProductType={productType}
                        onProductTypeChange={(type: string) =>
                            dispatch(setProductType(type as ProductTypeEnum))
                        }
                        isLoadingTranslations={false}
                        navItems={productNavItems}
                    />
                </div>

                <div className="p-product-range__content__categories">
                    {isLoading || isProcessingCategories ? (
                        <CategoryItemSkeleton />
                    ) : (
                        filteredCategories.map(
                            (category: CategoryListInterface) => (
                                <CategoryItem
                                    key={category.id}
                                    category={category}
                                    products={category.products}
                                    gridLayout={gridLayout}
                                    standardActive={
                                        filteredCategories.length === 1
                                    }
                                    productImages={productImages}
                                />
                            ),
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductRangePageContainer;
